import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, NoPreloading, PreloadAllModules, RouterModule } from '@angular/router';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import {MatNativeDateModule} from "@angular/material/core";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule, MAT_MOMENT_DATE_FORMATS} from "@angular/material-moment-adapter";
import { MatTooltipModule } from '@angular/material/tooltip';

import { registerLocaleData } from '@angular/common';
import localeEsCo from '@angular/common/locales/es-CO';
registerLocaleData(localeEsCo)

// Dentro de un iframe (la vista del trabajador del Centro de Formación) la app
// solo necesita esa página: precargar todos los módulos otra vez sobraría.
const dentroDeIframe = (() => {
    try { return window.self !== window.top; } catch { return true; }
})();

const routerConfig: ExtraOptions = {
    preloadingStrategy: dentroDeIframe ? NoPreloading : PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    bindToComponentInputs: true,
};

const MY_DATE_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        MatNativeDateModule,
        MatMomentDateModule,
        MatDatepickerModule,
        MatTooltipModule
    ],
    providers: [
        { provide: MAT_MOMENT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
